import _slicedToArray from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.object.from-entries.js";
import { require as requireDefault } from "d3-require";
import DOM from "./dom/index.js";
import Files from "./files/index.js";
import { NoFileAttachments } from "./fileAttachment.js";
import Generators from "./generators/index.js";
import _html from "./html.js";
import _md from "./md.js";
import _Mutable from "./mutable.js";
import now from "./now.js";
import Promises from "./promises/index.js";
import _resolve from "./resolve.js";
import requirer from "./require.js";
import _SQLite, { SQLiteDatabaseClient as _SQLiteDatabaseClient } from "./sqlite.js";
import _svg from "./svg.js";
import _tex from "./tex.js";
import vegalite from "./vegalite.js";
import width from "./width.js";
import { arrow, d3 as _d, graphviz, htl as _htl, inputs, lodash, plot } from "./dependencies.js";
export default Object.assign(function Library(resolver) {
  var _require = requirer(resolver);

  Object.defineProperties(this, properties({
    FileAttachment: function FileAttachment() {
      return NoFileAttachments;
    },
    Arrow: function Arrow() {
      return _require(arrow.resolve());
    },
    Inputs: function Inputs() {
      return _require(inputs.resolve());
    },
    Mutable: function Mutable() {
      return _Mutable;
    },
    Plot: function Plot() {
      return _require(plot.resolve());
    },
    SQLite: function SQLite() {
      return _SQLite(_require);
    },
    SQLiteDatabaseClient: function SQLiteDatabaseClient() {
      return _SQLiteDatabaseClient;
    },
    _: function _() {
      return _require(lodash.resolve());
    },
    d3: function d3() {
      return _require(_d.resolve());
    },
    dot: function dot() {
      return _require(graphviz.resolve());
    },
    htl: function htl() {
      return _require(_htl.resolve());
    },
    html: function html() {
      return _html;
    },
    md: function md() {
      return _md(_require);
    },
    now: now,
    require: function require() {
      return _require;
    },
    resolve: function resolve() {
      return _resolve;
    },
    svg: function svg() {
      return _svg;
    },
    tex: function tex() {
      return _tex(_require);
    },
    vl: function vl() {
      return vegalite(_require);
    },
    width: width,
    // Note: these are namespace objects, and thus exposed directly rather than
    // being wrapped in a function. This allows library.Generators to resolve,
    // rather than needing module.value.
    DOM: DOM,
    Files: Files,
    Generators: Generators,
    Promises: Promises
  }));
}, {
  resolve: requireDefault.resolve
});

function properties(values) {
  return Object.fromEntries(Object.entries(values).map(property));
}

function property(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  return [key, {
    value: value,
    writable: true,
    enumerable: true
  }];
}